module.exports = "<a href='#'>Contact</a>\r\n<a href='#'>Mentions légales</a>\r\n<a href='#'>Crédits</a>"